import { getOrCreateSocket } from "socket/socket";
import { store } from "store/store";

// eslint-disable-next-line @typescript-eslint/naming-convention
export const debug_addRandomAnimal = () => {
  const socket = getOrCreateSocket();
  socket.emit("debug_addRandomAnimal", store.currentRoom);
};
